import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsTextModel } from "src/app/models/widgets/widgets-text.model";
import { ValdnWidgetsYearModel } from "src/app/models/widgets-validation/valdn-widgets-year.model";
import { WidgetsFieldModel } from "src/app/models/widgets/widgets-field.model";

@Injectable({
  providedIn: 'root'
})
export class CloneValidationService extends AbstractClone {

  constructor() {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
      let orgWidget = origWidget as ValdnWidgetsYearModel;
      const inputDest = destWidget as WidgetsFieldModel;
      const newValidation = new ValdnWidgetsYearModel();

      // TODO: Change validation labels as well
      newValidation.type = orgWidget.type;
      newValidation.template = orgWidget.template;
      inputDest.children.push(newValidation);
  }
}
